"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataHooks = void 0;
var dataHooks;
(function (dataHooks) {
    dataHooks["progressIndicator"] = "progress-indicator";
    dataHooks["label"] = "label";
    dataHooks["successIcon"] = "success-icon";
    dataHooks["errorIcon"] = "error-icon";
    dataHooks["progressArcForeground"] = "progressarc-foreground";
    dataHooks["progressArcBackground"] = "progressarc-background";
})(dataHooks = exports.dataHooks || (exports.dataHooks = {}));
//# sourceMappingURL=constants.js.map